import Icon from './Icon'

export * from './Icon'

export default Icon
